export default __webpack_public_path__ + "static/media/wohnungen_intro_web-md@1x.b37b7a97.jpg";